import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const PDPAccordionPanel = (props) => {
    const { className, accordionStyle, children, ...other } = props;
    let accordionStyles = {};
    if (accordionStyle !== undefined) {
        accordionStyles = accordionStyle;
    } else {
        accordionStyles = "w-full";
    }
    return (
        <div className={classNames(accordionStyles, className)} {...other}>
            {children}
        </div>
    );
};

PDPAccordionPanel.propTypes = {
    className: PropTypes.string,
    accordionStyle: PropTypes.object,
    children: PropTypes.node,
};

export default PDPAccordionPanel;
